// extracted by mini-css-extract-plugin
module.exports = {"list":"Chars_list__pqz_3"};